import { customAlphabet } from 'nanoid'

interface RandomIdOptions {
  withLowerCaseCharacters?: boolean
  withUppercaseCharacters?: boolean
  withSpecialCharacters?: boolean
  withNumbers?: boolean
}

export function randomId(
  length = 10,
  {
    withLowerCaseCharacters = true,
    withUppercaseCharacters = true,
    withSpecialCharacters = true,
    withNumbers = true,
  }: RandomIdOptions = {},
) {
  let alphabet = ''

  if (withLowerCaseCharacters) {
    alphabet += 'abcdefghijklmnopqrstuvwxyz'
  }

  if (withUppercaseCharacters) {
    alphabet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  }

  if (withNumbers) {
    alphabet += '0123456789'
  }

  if (withSpecialCharacters) {
    alphabet += '-_'
  }

  const nanoid = customAlphabet(alphabet, length)

  return nanoid()
}

export function generatePrimaryKey(prefix: string) {
  if (!prefix) {
    throw new Error('Prefix is required')
  }

  return `${prefix}_${randomId(20, {
    withNumbers: true,
    withLowerCaseCharacters: true,
    withUppercaseCharacters: true,
    withSpecialCharacters: false,
  })}`
}

export function generateRandomNumber(length: number) {
  return randomId(length, {
    withNumbers: true,
    withLowerCaseCharacters: false,
    withUppercaseCharacters: false,
    withSpecialCharacters: false,
  })
}
